import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';
import { HeaderBasicAuthorizationService } from '../../../../../shared/services/header-basic-authorization.service';
import { ApiEnum } from '../../../../../shared/enums/api.enum';
import { PostulanteModel } from '../model/postulante.model';
import { PostulanteExtendedModel } from '../model/postulante-extended.model';
import { DerechoHabienteModel } from '../model/derecho-habiente.model';
import { AngularFireAuth } from 'angularfire2/auth';
@Injectable({
  providedIn: 'root'
})
export class TrabajadorService {

  constructor(
    private http: HttpClient,
    private headerBasicAuthorization: HeaderBasicAuthorizationService,
    private _auth:AngularFireAuth
  ) {
  }
  
  
  public getEmpresasList() {
    return this.http.get(`${environment.api.WS_HCM.url}/Trabajador/getEmpresasList`,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }
  public getNacionalidadList() {
    return this.http.get(`${environment.api.WS_HCM.url}/Trabajador/getNacionalidadList`,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }
  public _ListarSedeLaboral() {
    return this.http.get(`${environment.api.WS_HCM.url}/Trabajador/_ListarSedeLaboral`,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }
  public _ListarCargoTrabajador() {
    return this.http.get(`${environment.api.WS_HCM.url}/Trabajador/_ListarCargoTrabajador`,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }
  public _ListarCondicionPostulante() {
    return this.http.get(`${environment.api.WS_HCM.url}/Trabajador/_ListarCondicionPostulante`,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }
  public _ListarStatusProceso() {
    return this.http.get(`${environment.api.WS_HCM.url}/Trabajador/_ListarStatusProceso`,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  public getContratados_list(model: any): Observable<Array<PostulanteModel>>  {
    return this.http.post<Array<PostulanteModel>>(`${environment.api.WS_HCM.url}/Trabajador/getContratados_list`,model,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  public getContratados_listExtended(model: any): Observable<Array<PostulanteExtendedModel>>  {
    return this.http.post<Array<PostulanteExtendedModel>>(`${environment.api.WS_HCM.url}/Trabajador/getContratados_listExtended`,model,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  public getDerechoHabientes_list(ids: string): Observable<Array<DerechoHabienteModel>> {
    return this.http.post<Array<DerechoHabienteModel>>(`${environment.api.WS_HCM.url}/Trabajador/getDerechoHabientes_list`,{
      ids
    },
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  public getFichasPersonal() {
    return this.http.get(`${environment.api.WS_HCM.url}/Trabajador/getFichasPersonal`,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  
  public getModeloContrato_byPostulante(idpostulante) {
    return this.http.get(`${environment.api.WS_HCM.url}/Trabajador/getModeloContrato_byPostulante?Postulante=${idpostulante}`,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  public verifyModeloContrato_byPostulanteID(idpostulante) {
    return this.http.get(`${environment.api.WS_HCM.url}/Trabajador/verifyModeloContrato_byPostulanteID?Postulante=${idpostulante}`,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  public getFormateriaTrabajo(Empresa) {
    return this.http.get(`${environment.api.WS_HCM.url}/Trabajador/getFormateriaTrabajo?Empresa=${Empresa}`,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }
  public getFormateriaTrabajo_byCuenta(concuenta:Boolean) {
    return this.http.get(`${environment.api.WS_HCM.url}/Trabajador/getFormateriaTrabajo_byCuenta?ConCuenta=${concuenta}`,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }
  


  public getFotoByName(FileName) {
    return this.http.get(`${environment.api.WS_HCM.url}/Trabajador/getFotoByName?FileName=${FileName}`,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  public getFotoByPostulante(Postulante) {
    return this.http.get(`${environment.api.WS_HCM.url}/Trabajador/getFotoByPostulante?Postulante=${Postulante}`,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  public getConvertB64Dox_to_B64PDF(b64string) {
    return this.http.post(`${environment.api.WS_HCM.url}/Converter/getConvertB64Dox_to_B64PDF`,{base64: b64string},
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }
  


  public getModeloContrato_byPostulanteXML(xml) {
    return this.http.post(`${environment.api.WS_HCM.url}/Trabajador/getModeloContrato_byPostulanteXML`,{XML: xml},
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }
  
  public updateAFPData(array_object) {
    return this.http.post(`${environment.api.WS_HCM.url}/Trabajador/updateAFPData`,array_object,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  public getEmpleados() {
    return this.http.get(`${environment.api.WS_HCM.url}/Trabajador/getEmpleados`,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  public getModeloContratos(data) {
    return this.http.post(`${environment.api.WS_HCM.url}/Trabajador/getModeloContratos`, data,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  public getFormateriasTrabajo(data) {
    return this.http.post(`${environment.api.WS_HCM.url}/Trabajador/getFormateriasTrabajo`, data,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  public _ListarFiltros() {
    return this.http.get(`${environment.api.WS_HCM.url}/Trabajador/_ListarFiltros`,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  public getTrabajadores(model: any) {
    return this.http.post(`${environment.api.WS_HCM.url}/Trabajador/getTrabajadores`,model,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  cargar(files: Array<any>): Observable<any> {
    const formData = new FormData();

    for (let i = 0; i < files.length; i++) {
      formData.append(`file[${i}]`, files[i]);
    }

    const url = `${environment.api.WS_HCM.url}/Archivo/Cargar`;
    return this.http.post<any>(url, formData);
  }

  public importAccionMasivaPersonal(data) {
    return this.http.post(`${environment.api.WS_HCM.url}/Trabajador/importAccionMasivaPersonal`, data,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  public getSupervisorList() {
    return this.http.get(`${environment.api.WS_HCM.url}/Trabajador/getSupervisorList`,
    { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
  .pipe( map( data => data ));
  }

  public getPostulantesEdicion(TipoFecha, Fecha, Posicion, Sede, Dni) {
    return this.http.get(`${environment.api.WS_HCM.url}/Trabajador/getPostulantesEdicion?TipoFecha=${TipoFecha}&Fecha=${Fecha}&Posicion=${Posicion}&Sede=${Sede}&Dni=${Dni}`,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  public getCargaInicialCombos() {
    return this.http.get(`${environment.api.WS_HCM.url}/Trabajador/getCargaInicialCombos`,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  public ActualizacionDatosPostulantes(datos) {
    return this.http.post(`${environment.api.WS_HCM.url}/Trabajador/ActualizacionDatosPostulantes`, { datos: datos },
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  public ActualizacionDatosPostulantesIndividual(datos) {
    return this.http.post(`${environment.api.WS_HCM.url}/Trabajador/ActualizacionDatosPostulantesIndividual`, { datos: datos },
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  public SaveFirmaPostulante(model) {
    return this.http.post(`${environment.api.WS_HCM.url}/Trabajador/SaveFirmaPostulante`, model,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  public GetFirma(fileName) {
    return this.http.get(`${environment.api.WS_HCM.url}/Trabajador/GetFirma?fileName=${fileName}`,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  public getContratados_listProrroga(model: any): Observable<Array<PostulanteModel>>  {
    return this.http.post<Array<PostulanteModel>>(`${environment.api.WS_HCM.url}/Trabajador/getContratados_listProrroga`,model,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  public _GetTipoEmpleado() {
    return this.http.get(`${environment.api.WS_HCM.url}/Trabajador/getTipoEmpleado`,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  public _GetListarModelosContrato() {
    return this.http.get(`${environment.api.WS_HCM.url}/Trabajador/getListarModelosContrato`,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  public _SaveProrrogaContratos(model) {
    return this.http.post(`${environment.api.WS_HCM.url}/Trabajador/saveProrrogaContratos`, model,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }
  
  public _SaveUrlArchivoContratos(model) {
    return this.http.post(`${environment.api.WS_HCM.url}/Trabajador/saveUrlArchivoContratos`, model,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  

}
